module.exports = __webpack_public_path__ + "7f2faa7721af83df3783fad284c68fdd.png";